import React from 'react';
import { StyledSpinner } from './styles';
import type { SpinnerPosition } from './types';

export const getSpinnerSize = (size: number): React.CSSProperties => {
  return {
    height: size,
    width: size,
    borderWidth: spinnerBorderWidth(size),
  };
};

export const spinnerBorderWidth = (size: number) => {
  if (size < 18) {
    return 2;
  }

  if (size > 36) {
    return 6;
  }

  return 4;
};

export const Spinner: React.FC<SpinnerProps> = ({
  isActive = false,
  position = 'center',
  size = 24,
}) => {
  const spinnerSize = getSpinnerSize(size);

  return isActive ? (
    <StyledSpinner style={spinnerSize} position={position} />
  ) : null;
};
interface SpinnerProps {
  isActive?: boolean;
  position?: SpinnerPosition;
  size?: number;
}
